// QuickActionButton — icon + label action tile. One of the "2–4 quick actions"
// required by the Homepage screen type. Used on Dashboard and Landing.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './quick-action-button.css';

export function QuickActionButton({ icon, label, sub, title, tone = 'primary', onClick, className }) {
  return (
    <button
      type="button"
      className={cx('quick-action', `quick-action--${tone}`, className)}
      onClick={onClick}
      title={title}
    >
      <span className="quick-action__icon">{icon}</span>
      <span className="quick-action__text">
        <span className="quick-action__label">{label}</span>
        {sub && <span className="quick-action__sub">{sub}</span>}
      </span>
    </button>
  );
}

QuickActionButton.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.node.isRequired,
  sub: PropTypes.node,
  /**
   * Native tooltip. For a tile that shows its label alone, this is where the supporting
   * line goes — the sponsor grid does exactly that, so six tiles stay one line tall.
   */
  title: PropTypes.string,
  tone: PropTypes.oneOf(['primary', 'success', 'warning', 'purple', 'neutral']),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default QuickActionButton;
